import Vue from 'vue'
import { createAndMountInstance } from 'util/loader-helper'
import { widgetLibraries } from 'init/command-queue'
import { QaConfig as IQaConfig } from 'services/api-service'
import qaConfig, { loadConfig } from './qa.config'
import QaWidget from './qa'

let root: Vue

export const type = 'qa'

export function initialize() {
  return createAndMountInstance(root, QaWidget, qaConfig.widgetDivId)
    .then(instance => root = instance)
}

export function loadWidget(widgetConfig: IQaConfig) {
  return new Promise((resolve) => {
    loadConfig(widgetConfig)
    // no commands for qa yet
    widgetLibraries.qa = {}
    initialize().then(() => resolve())
  })
}

export function getInstance() {
  return root
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/qa/qa-loader.ts